<template>
  <div v-if="isPublicRoute" id="app" class="public-app">
    <router-view></router-view>
  </div>
  <div v-else-if="!auth || isLoginRoute" id="app">
    <Login/>
  </div>
  <div v-else id="app">
    <Sidebar v-if="$route.name != 'Venta'"/>
    <section id="content" :class="($route.name != 'Venta') ? 'content' : ''">
      <router-view></router-view>
      <Modal/>
      <DashboardNotices :notices="dashboardNotices" />
    </section> 
  </div>
</template>

<script>
  import Login from '@/components/Login.vue';
  import Sidebar from '@/components/Sidebar.vue';
  import Modal from '@/components/Notifications-modal.vue';
  import DashboardNotices from '@/components/DashboardNotices.vue';
  import dashboardNotices from '@/config/dashboardNotices';
  export default {
    components:{
      Login,
      Sidebar,
      Modal,
      DashboardNotices
    },
    data() {
      return { dashboardNotices };
    },
    methods:{

    },
    computed:{
      auth(){
        return this.$store.getters.getAuth;
      },
      isLoginRoute(){
        return this.$route.path === '/login';
      },
      isPublicRoute(){
        return Boolean(this.$route.meta && this.$route.meta.public);
      }
      
    },
  }
</script>

<style lang="scss">
  #app{
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    background-color: $light;
    section{
      &.content{
        margin-left: 75px;
      }
    }
    .button{
      text-transform: uppercase;
      font-weight: 600;
      &.is-circle{
        border-radius: 50%!important;
      }
    }
    .dropdown-item{
      text-transform: uppercase;
      font-weight: 500;
    }
    .collapse{
        &.card{
            .card-header{
                box-shadow: none!important;
            }
            .card-content{
              .label{
                    color: $primary!important;
              }   
              input.input, select, textarea{
                  border-top: 0;
                  border-bottom: 2px solid $warning;
                  border-left: 0;
                  border-right: 0;
              }
              button{
                  &.is-circle{
                      border-radius: 50%!important;
                  }
                  &.is-text{
                      text-decoration: none!important;
                  }
              }
            }
        }
    }
    .content ul{
      list-style: none;
      margin: 0;
    }

    @media (max-width: 768px) {
      section.content {
        box-sizing: border-box;
        height: 100vh;
        margin-left: 0;
        padding-top: 54px;
        padding-bottom: calc(64px + env(safe-area-inset-bottom));
        overflow: auto;
      }
    }
  }
  .dialog{
    .modal-card{
      .modal-card-foot{
        padding-top: 0;
        border-top: 0;
        background-color: $white;
        border-radius: 0;
      }
    }
  }
  #app.public-app {
    max-height: none;
    min-height: 100vh;
    overflow: auto;
  }
</style>
